<!-- Button - parent must be relative -->
<button type="button"
    class="absolute right-2 top-1/2 -translate-y-1/2 px-2 py-1 rounded hover:bg-neutral-100 focus:outline-none disabled:opacity-50"
    (click)="toggleCalc($event)" [disabled]="disabled" aria-label="Calculator">
    <img src="assets/icons/calculator-black.svg" class="h-4 w-4" alt="{{ 'shared.calculator' | transloco }}">
</button>

<!-- Popup -->
<div *ngIf="showCalc"
    class="calc-pop absolute z-[9999] right-0 mt-2 w-72 rounded-xl border border-border bg-white shadow-xl p-3"
    (click)="$event.stopPropagation()" role="dialog" aria-modal="true">

    <div class="flex items-center justify-between mb-2">
        <p class="text-sm font-bold text-black">{{ 'shared.calculator' | transloco }}</p>
        <button type="button" class="btn-reset text-neutral-500 hover:text-black" (click)="closeCalc()"
            aria-label="Close calculator" title="Close (Esc)">x</button>
    </div>

    <input #calcInput type="text" class="w-full border border-border rounded-lg px-2 py-2 text-sm"
        [(ngModel)]="calcExpr" (keydown)="onCalcKeydown($event)" (input)="sanitizeCalcExpr()" placeholder="=1,2+2,3"
        autocomplete="off" />

    <div class="mt-2 text-xs">
        <ng-container *ngIf="calcPreview !== null; else info">
            = {{ calcPreview }}
        </ng-container>
        <ng-template #info>
            <span class="text-neutral-500">
                {{ 'shared.calculator_desc.type_expression' | transloco }} <code>=14,23+6,28</code>.
            </span>
            <p>
                <span class="text-neutral-500">
                    {{ 'shared.calculator_desc.only' | transloco }} <strong>{{ 'shared.calculator_desc.operations' |
                        transloco }}</strong> {{ 'shared.calculator_desc.are_allowed' | transloco }}.
                </span>
            </p>
        </ng-template>
    </div>
</div>